/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import useStyles from './style';

const OrderNotification = ({
    count = 0,
    onClose = () => {},
    link = '/seller/order/orderlist/unconfirmed',
    title = 'Order Belum Dikonfirmasi',
}) => {
    const classes = useStyles();
    if (count <= 0) return null;

    return (
        <div className={classes.container} id="order-notification-popup">
            <div className={classes.notification}>
                <button type="button" className={classes.closeButton} onClick={onClose} aria-label="Close notification">
                    ×
                </button>
                <div className={classes.content}>
                    <div className={classes.icon}>⚠️</div>
                    <div className={classes.text}>
                        <strong className={classes.title}>{title}</strong>
                        <p className={classes.message}>
                            Anda memiliki
                            {' '}
                            {count}
                            {' '}
                            order yang belum dikonfirmasi.
                        </p>
                        <a href={link} className={classes.link} onClick={onClose}>
                            Klik di sini untuk melihat →
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderNotification;
